import BaseService from './BaseService';
import entities from 'src/config/entities';

class ClientTokensService extends BaseService {

  constructor() {
    super({ entity: entities.CLIENT_TOKEN });
  }
}

export default new ClientTokensService();
